import { groupId, hiddenCompaniesId } from './enum'
import adminApiClient from '../api/admin-api-client'

/**
 *
 *
 * Example props
 * [
 *  { "companyId": 8, "propertyId": 5, "propertyValue": "fi" }
 *  { "companyId": 8, "propertyId": 8, "propertyValue": "" }
 * ]
 *
 * Example propsDefinition
 * [
 *   {
 *    "propertyId": 5,
 *    "propertyName": "Language",
 *    "propertyType": 0,
 *    "propertyValueType": "Language",
 *    "propertyDesc": "[default]Language[sv-SE]Språk",
 *    "selection": [
 *	    {
 *        "selectionKey": "sv",
 *        "selectionValue": "[default]Sweden[sv-SE]Sverige[fi-FI]Ruotsi[no-NO]Sverige[da-DK]Sverige"
 *	    },
 *	    {
 *	       "selectionKey": "fi",
 *	       "selectionValue": "[default]Finland[fi-FI]Suomi"
 *      },
 *     ]
 *   }
 * ]
 * @deprecated
 *
 * @param {array} props - user / company props
 * @param {array} propsDefinitons - props where logged user can access
 *
 * @returns {array} - array of formatted property objects
 */
export const propertyMerger = (props, propsDefinitons) => {
  if (!props || !props.length || !propsDefinitons || !propsDefinitons.length) {
    return []
  }
  const mergedProps = []
  propsDefinitons.forEach((p) => {
    const hasThisProp = props.find((prop) => prop.propertyId == p.propertyId)
    if (hasThisProp) {
      mergedProps.push({
        ...p,
        ...hasThisProp,
      })
    }
  })
  return mergedProps
}

export const currentEnvironment = () => {
  // Allow override via localStorage for local testing
  // Usage: In browser console, run: localStorage.setItem('FORCE_ENV', 'production')
  // This allows testing with production APIs without affecting tests (tests don't use localStorage)
  try {
    // eslint-disable-next-line no-undef
    if (typeof window !== 'undefined' && window.localStorage) {
      // eslint-disable-next-line no-undef
      const forcedEnv = window.localStorage.getItem('FORCE_ENV')
      if (forcedEnv && ['development', 'staging', 'production'].includes(forcedEnv)) {
        return forcedEnv
      }
    }
  } catch {
    // localStorage might not be available (e.g., in tests or private browsing mode)
  }

  // eslint-disable-next-line no-undef
  if (window.location.hostname == 'localhost') return 'development'
  // eslint-disable-next-line no-undef
  if (window.location.hostname.includes('.staging')) return 'staging'
  else return 'production'
}
/**
 *
 * @param {*} gId
 * @returns
 */
export const userGroupIcon = (gId) => {
  return (
    {
      [groupId.PortalSuperAdmin]: 'fas fa-user-robot',
      [groupId.HostingAdmin]: 'fas fa-server',
      [groupId.PortalGlobalAdmin]: 'fas fa-globe',
      [groupId.PartnerAdmin]: 'fas fa-user-tie',
      [groupId.PortalUserAdmin]: 'fas fa-shield-alt',
      [groupId.SubdivisionAdmin]: 'fas fa-shield-alt',
      [groupId.PortalUser]: 'fas fa-user',
    }[gId] ?? 'fas fa-question-square'
  )
}

export const getCompanyByFiscalId = (fiscalId) => {
  return adminApiClient
    .getCompanyByFiscalId(fiscalId)
    .then((response) => {
      if (response.status === 404) {
        return false
      }
      return response
    })
    .catch((err) => {
      if (err.response?.data?.status === 404) {
        return false
      }
      throw err
    })
}

/**
 * True when a failed request was rejected because the record already exists.
 * The API answers 409 for these (see AlreadyExistsException), and puts the status in the
 * ProblemDetails body as well, which is what some interceptors leave us with.
 *
 * @param {*} error the error thrown by the api client
 * @returns {Boolean}
 */
export const isAlreadyExistsError = (error) => {
  return error?.response?.status === 409 || error?.response?.data?.status === 409
}

export const isIAnHiddenCompany = (companyId) => {
  const navigateToCompany = companyId ? companyId : parseInt(window.location.pathname.split('/')[2])
  return hiddenCompaniesId.some((x) => x === navigateToCompany)
}
